export default {
  loaded: false,
}
